import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { LoadingButton } from "@mui/lab";
import { useStartIdvCheck } from "./useStartIdvCheck";

export const StartIdvCheckButton = ({
  sailorIdvDetails,
  disabled,
  isFirstCheck,
}) => {
  const { startIdvCheck, loading, complete } = useStartIdvCheck();
  const { sailorId, issuingCountry, documentType } = sailorIdvDetails;

  return (
    <LoadingButton
      size="small"
      variant="contained"
      startIcon={<PersonSearchIcon />}
      onClick={() => startIdvCheck({ sailorId, issuingCountry, documentType })}
      disabled={disabled}
      loading={loading}
      loadingPosition="start"
    >
      Create {isFirstCheck ? "" : " New"} ID&V Invite
    </LoadingButton>
  );
};
